<template>
  <div class="salary-box">
    <div id="eChart">

    </div>
    <div id="eChart1">

    </div>
<!--    <p class="title">该行业薪资集中分布在 {{location}}k</p>-->
<!--    <div class="vertical-box">-->
<!--      <div class="bar-box">-->
<!--        <div v-for="item in data.salary" class="bar-item" :style="{height: (item.percent / max) * 100 +'%'}">-->

<!--        </div>-->
<!--      </div>-->
<!--      <div class="x-list">-->
<!--        <div class="x-item" v-for="(item, index) in data.salary" :key="index">-->
<!--          {{item.salary_range}}k-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
<!--    <p class="title">该行业平均薪资与行业龙头薪资相比：</p>-->
<!--    <div class="horizontal-box">-->
<!--      <div class="line"></div>-->
<!--      <div class="bar-item">-->
<!--        <p class="x-name">平均薪资</p>-->
<!--        <div class="x-bar-max">-->
<!--          <div class="x-bar" :style="{width: (data.average / 1000) / (Number(data.salary[data.salary.length-1].salary_range.replace('>', ''))) * 100 + '%'}"></div>-->
<!--        </div>-->
<!--        <p class="salary">{{data.average / 1000}}k/月</p>-->
<!--      </div>-->
<!--      <div class="bar-item">-->
<!--        <p class="x-name">行业龙头</p>-->
<!--        <div class="x-bar-max">-->
<!--          <div class="x-bar"></div>-->
<!--        </div>-->
<!--        <p class="salary">{{data.salary[data.salary.length-1].salary_range.replace('>', '')}}k/月</p>-->
<!--      </div>-->
<!--    </div>-->
  </div>
</template>

<script>
  const echarts = require('echarts');
  const handleSalaryModule = (xinzhi_info) => {
    try {
      let {annual_year_cash_dist_key, profession_salary, area_salary, annual_year_cash_key, profession_salary_key} = xinzhi_info

      let key = {
        "10":"10分位",
        "25":"25分位",
        "50":"50分位",
        "75":"75分位",
        "90":"90分位",
        "average":"平均数"
      }
      let markPoint = null
      if (annual_year_cash_key !== null ){
        let x = {
          '10': 37,
          '25': 127,
          '50': 219,
          '75': 310,
          '90': 401
        }
        markPoint = {}
        markPoint.data=[{x:x[annual_year_cash_key],y: (Number(annual_year_cash_dist_key['90'] || annual_year_cash_dist_key['75']) - Number(annual_year_cash_dist_key[annual_year_cash_key]))  * ( 228 / Number(annual_year_cash_dist_key['90'] || annual_year_cash_dist_key['75'])) + 55 }]
      }
      //年现金收入分值位
      let percentile = {
        markPoint,
        x: Object.keys(annual_year_cash_dist_key).map(item=>{
          return key[item]
        }),
        y: Object.values(annual_year_cash_dist_key).map(item=>Number(item))
      }


      let title = profession_salary.name
      delete profession_salary.name
      let levelType = {
        middle: "中级",
        senior: "总监专家",
        manager: "经理/资深",
        primary: "初级",
        advanced: "主管高级",
        president: "副总及以上"
      }
      let keys = ["primary","middle", "advanced", "manager", "senior", "president"]
      let nowKey = Object.keys(annual_year_cash_dist_key)
      if(nowKey.length > key.length) {
        keys.push([...nowKey.filter(item => !keys.includes(item))])
      }
      //薪酬水平
      let level = {
        key: keys.map(item=>levelType[item]),
        value1: keys.map(item=>{
          return Number(profession_salary[item]['annual_year_cash_dist_key']['25'])
        }),
        value2: keys.map(item=>{
          return Number(profession_salary[item]['annual_year_cash_dist_key']['75'])
        }),
      }


      return {
          percentile,
          level
      }
    }catch (e) {
      console.log("薪酬异常",e)
    }
  }
  export default {
    name: "Salary",
    props:{
      data:{
        type: Object,
        default: ()=>({})
      }
    },
    data(){
      return {
        max: 0,
        location: "",
        level: {},
        percentile: {}
      }
    },
    created() {
      this.level = handleSalaryModule(this.data.info).level
      this.percentile = handleSalaryModule(this.data.info).percentile
    },
    mounted() {
      let myChart = echarts.init(document.querySelector('#eChart'))
      // 开始渲染
      myChart.setOption({
        title:[{
          show: true,
          text: "薪酬百分比占位图（年薪）",
          textStyle: {
            color: "#D5C3FF",
            fontSize: 14,
            fontWeight: 400
          },
          left:0
        },{
          text: '万元',
          textStyle: {
            color: "#D5C3FF",
            fontSize: 14,
            fontWeight: 500
          },
          right:0
        }],
        tooltip:{
          show: true,
          borderWidth:0
        },
        grid:{
          left: 24,
          right: 2,
          bottom: 24,
          top: 45
        },
        xAxis: {
          type: 'category',
          data: this.percentile.x.slice(0,5),
          axisLine: {
            lineStyle:{
              color: "#4E26B1"
            }
          },
          axisTick:{
            show: false
          },
          axisLabel: {
            color: "#D5C3FF"
          }
        },
        yAxis: {
          type: 'value',
          axisLine: {
            show: true,
            lineStyle:{
              color: "#4E26B1"
            }
          },
          axisTick:{
            show: false
          },
          axisLabel: {
            color: "#D5C3FF"
          },
          splitLine:{
            lineStyle:{
              type: 'dashed',
              color: "rgba(244, 244, 244, 0.2)"
            }
          }
        },
        series: [{
          data: this.percentile.y.slice(0,5),
          type: 'bar',
          barWidth: 11,
          itemStyle: {
            normal: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: '#6B51E5'
              }, {
                offset: 1,
                color: '#33167A'
              }]),
              barBorderRadius: [9, 9, 0, 0],
            }
          },
          label: {
            show: true,
            position: 'top',
            color: "#fff"
          }
        }]
      })
      let myChart1 = echarts.init(document.querySelector('#eChart1'))
      // 开始渲染

      myChart1.setOption({
        title: [{
          text: '不限薪酬水平（年薪）',
          textStyle: {
            color: "#D5C3FF",
            fontSize: 14,
            fontWeight: 500
          },
          left:0
        },{
          text: '万元',
          textStyle: {
            color: "#D5C3FF",
            fontSize: 14,
            fontWeight: 500
          },
          right:0
        }],
        tooltip:{
          show: true,
          borderWidth:0
        },
        legend: {
          data: this.level.key,
          top: 0,
          right: 0,
          textStyle:{
            color:"#fff"
          },
          itemWidth: 19,
          itemHeight: 6,
          borderRadius: 10
        },
        grid: {
          left: 0,
          right: 10,
          bottom: 0,
          containLabel: true,
          top:40
        },
        xAxis: {
          type: 'value',
          axisLine: {
            show: true,
            lineStyle:{
              color: "#4E26B1"
            }
          },
          axisTick:{
            show: false
          },
          axisLabel: {
            color: "#D5C3FF"
          },
          splitLine:{
            lineStyle:{
              type: 'dashed',
              color: "rgba(244, 244, 244, 0.2)"
            }
          },
        },
        yAxis: {
          type: 'category',
          data: this.level.key,
          axisLine: {
            show: true,
            lineStyle:{
              color: "#4E26B1"
            }
          },
          axisTick:{
            show: false
          },
          axisLabel: {
            color: "#D5C3FF"
          }
        },
        series: [
          {
            type: 'bar',
            stack: '总量',
            itemStyle: {
              barBorderColor: 'rgba(0,0,0,0)',
              color: 'rgba(0,0,0,0)'
            },
            emphasis: {
              itemStyle: {
                barBorderColor: 'rgba(0,0,0,0)',
                color: 'rgba(0,0,0,0)'
              }
            },
            data: this.level.value1
          },
          {
            name: '年总现金收入',
            type: 'bar',
            stack: '总量',
            data: this.level.value2,
            barWidth: 12,
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(1, 0, 0, 0, [{
                  offset: 0,
                  color: '#6B51E5'
                }, {
                  offset: 1,
                  color: '#33167A'
                }]),
                barBorderRadius: 6,
              }
            }
          }
        ]
      })
    }
  }
</script>

<style scoped lang="scss">
.salary-box{
  padding: 30px 20px 10px;
  box-sizing: border-box;
  #eChart{
    width: 100%;
    height: 200px;
    margin-bottom: 40px;
  }
  #eChart1{
    width: 100%;
    height: 200px;
  }
  .title{
    font-size: 14px;
    font-weight: 400;
    color: #D5C3FF;
    line-height: 20px;
    margin-bottom: 30px;
  }
  .vertical-box{
    height: 134px;
    margin-bottom: 40px;
    .bar-box{
      height: 107px;
      border-bottom: 1px solid #4E26B1;
      display: flex;
      align-items: flex-end;
      justify-content: space-around;
      .bar-item{
        width: 24px;
        background: linear-gradient(180deg, #6B51E5 0%, #33167A 100%);
      }
    }
    .x-list{
      display: flex;
      justify-content: space-around;
      margin-top: 10px;
      .x-item{
        font-size: 11px;
        font-weight: 400;
        color: #D5C3FF;
        line-height: 16px;
      }
    }
  }
  .horizontal-box{
    position: relative;
    margin-top: 10px;
    .line{
      position: absolute;
      height: 83px;
      top: -10px;
      left: 70px;
      width: 1px;
      background: #4E26B1;
    }
    .bar-item{
      display: flex;
      align-items: center;
      margin-bottom: 15px;
      .x-name{
        margin-right: 14px;
        font-weight: 400;
        color: #D5C3FF;
        line-height: 16px;
      }
      .x-bar-max{
        width: 152px;
        height: 24px;
        margin-right: 10px;
      }
      .x-bar{
        width: 152px;
        height: 24px;
        background: linear-gradient(270deg, #6B51E5 0%, #33167A 100%);
      }
      .salary{
        font-size: 11px;
        font-weight: 400;
        color: #D5C3FF;
        line-height: 16px;
      }
    }
  }
}
</style>